import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const LegendItemGroup = ({
    items = [],
    circleSize = 16,
}) => {
    return (
        <Box
            display="flex"
            flexDirection="row"
            flexWrap="wrap"
            gap={{xs: 1, sm: 2}}
        >
            {items.map((item, index) => (
                <Stack
                    key={index}
                    direction="row"
                    gap={.75}
                    alignItems="center"
                >
                    <Box
                        sx={{
                            width: circleSize,
                            height: circleSize,
                            bgcolor: item.color || "transparent",
                            color: item.color || "transparent",
                            borderRadius: "50%",
                        }}
                    >
                        {item.pattern ? item.pattern : <>&nbsp;</>}
                    </Box>
                    <Typography variant="body2">
                        {item.label}
                    </Typography>
                </Stack>
            ))}
        </Box>
    );
};

export default LegendItemGroup;